__turbopack_context__.v({
  "Button": "index-module__qyJ_Wq__Button",
});
